import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
       // borderBottomColor: '#000000',
       // borderBottomWidth: 0,
        border: 0,
        alignItems: 'center',
        //height: auto,
        fontSize:9,
        fontStyle: 'bold',
        lineHeight: 1.15,
        alignContent: 'flex-start'
    },
    marg_100: {
        width: '100%',
        margin: 6,
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        paddingLeft: 0,//8,
        fontStyle: 'bold',
    },
    marg_50: {
        width: '50%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'left',
        paddingRight: 0,//8,
    }, 
    marg_33: {
        width: '33%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'left',
        paddingRight: 0,//8,
    }, 
    marg_25: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'left',
        paddingRight: 0,//8,
    }, 
    
  });

  function styleDefine (index, lastAttribute100, lastOne) {
    let marg = styles.marg_100;
    switch(index) {
        case 1: marg = styles.marg_100; break;
        case 2: marg = styles.marg_50; break;
        case 3: marg = styles.marg_33; break;
        case 4: marg = styles.marg_25; break;
    }

    if(lastAttribute100 && lastOne) {
        marg = styles.marg_100;
    }

    return marg;
  }
const InvoiceTableRow = ({items, separator, lastAttribute100}) => {

    const itemsReduce = items.reduce(function (rows, key, index) { 
        return (index % separator == 0 ? rows.push([key]) 
          : rows[rows.length-1].push(key)) && rows;
      }, []);
     
    const rows = itemsReduce.map( item =>  
        <View style={styles.row} key={item[0].id.toString()}>
        {item.map(element => 
            <Text key={element.id.toString()} 
             style={styleDefine(separator, lastAttribute100, element.id === 10)} >
            {element.key} {element.value}
            </Text>
        )}
        
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
export default InvoiceTableRow